/* eslint-disable global-require */
/*
 * @Author: 朱璐
 * @Date: 2022-10-28 11:17:24
 * @Description: common图片
 */

export const IMG_MAINTENANCE = require('@/resources/images/maintenance.png');
export const IMG_LOADING = require('@/resources/images/loading.gif');
export const IMG_LOGO = require('@/resources/images/logo.png');
export const IMG_ICON_TO_TOP = require('@/resources/images/icon-top.png');
export const IMG_PRODUCT = require('@/resources/images/product-image.png');
export const IMG_GOOD_CARD_TAG = require('@/resources/images/good-card-tag.png');
export const IMG_STORES_EMPTY = require('@/resources/images/stores-empty.png');
export const IMG_ICON_NETWORK = require('@/resources/images/icon-network.png');
export const IMG_ICON_NOT_FOUND = require('@/resources/images/icon-not-found.png');
export const IMG_ICON_ORDER = require('@/resources/images/icon-order.png');
export const IMG_ICON_NOT_ADDRESS = require('@/resources/images/icon-not-address.png');
export const IMG_ICON_NOT_COUPON = require('@/resources/images/icon-not-coupon.png');
export const IMG_STORES_HEADER_BG = require('@/resources/images/stores-header-bg.png');
export const IMG_STORES_HEADER_RIGHT_BG = require('@/resources/images/stores-header-right-bg.png');
export const IMG_STORES_RED_CAR = require('@/resources/images/store-car.png');
export const IMG_ICON_NOT_POINTS = require('@/resources/images/icon-not-points.png');
export const IMG_ICON_NOT_COLLECT = require('@/resources/images/icon-not-collect.png');
export const IMG_ICON_COMMON_EMPTY = require('@/resources/images/icon-common-empty.png');
export const ICON_PROMOTION_LABEL_LEFT = require('@/resources/images/icon-promotion-label-left.png');
export const IMG_ICON_NO_EVALUATION = require('@/resources/images/icon-no-evaluation.png');
export const IMG_NO_DATA = require('@/resources/images/no-data.png');
export const IMG_ICON_LIVING_LOGO = require('@/resources/images/living-logo.png');
export const IMG_ICON_LOADING = require('@/resources/images/icon-loading.png');
export const ICON_EMPTY_CART = require('@/resources/images/empty-cart.png');
export const ICON_ADDRESS_TOP_BORDER = require('@/resources/images/icon-address-top-border.png');
export const ICON_NO_PRODUCT = require('@/resources/images/icon-no-product.png');
export const ICON_PROMOTION_LABEL = require('@/resources/images/icon-promotion-label.png');
export const IMG_COUPON_LOGO = require('@/resources/images/icon-coupon-logo.png');
export const IMG_CHINA_BANK = require('@/resources/images/img-china-bank.png');
export const IMG_QR_CODE = require('@/resources/images/qr-code.png');
export const IMG_E_SHOP = require('@/resources/images/eshop.png');
export const IMG_DOWNLOAD_LOGO = require('@/resources/images/download-logo.png');
export const IMG_DOWNLOAD_PAGE_LOGO = require('@/resources/images/download-page-logo.png');
export const IMG_DOWNLOAD_GUIDE = require('@/resources/images/guide-map.png');
export const ICON_VISA = require('@/resources/sprites-images/pay-icon/icons/7-visa.png');
export const ICON_MASTERCARD = require('@/resources/sprites-images/pay-icon/icons/3-mostercard.png');
export const ICON_WECHATPAY = require('@/resources/sprites-images/pay-icon/icons/8-wechatpay.png');
export const ICON_PAYME = require('@/resources/sprites-images/pay-icon/icons/5-payme.png');
export const ICON_ALIPAY = require('@/resources/sprites-images/pay-icon/icons/1-alipay.png');
export const ICON_BANK = require('@/resources/sprites-images/pay-icon/icons/9-banktransfer.png');
export const ICON_HS_BANK = require('@/resources/images/img-hs-bank.png');
